export default __webpack_public_path__ + "static/media/summary.8cb3da71.svg";